<template>
  <div class="footer__box">
    <div class="footer__content"></div>
    <div class="footer__copyright">
      <div>
        <a href="javascript:;">©2022 深圳速普数字技术服务有限公司</a>
        <a href="javascript:;">粤ICP备2021090255号</a>
      </div>
      <div>
        <a href="javascript:;">联系我们</a>
        <a href="javascript:;">法律声明</a>
        <a href="javascript:;">隐私保护</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="less" scoped>
.footer__box {
  color: #333;
  padding-top: 2px;
  position: relative;
  background: #f5f5f5;
  &::before {
    content: "";
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 2px;
    background: linear-gradient(to right, #f0f0f0, #f00, #0ff);
  }
  a {
    color: #333;
    text-decoration: none;
  }
  .footer__content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 1200px;
    margin: auto;
    padding: 20px 0;
  }
  .footer__content-item {
    width: 200px;
    display: inherit;
    flex-wrap: inherit;
    & > h3 {
      font-weight: 900;
    }
    & > h3,
    & > a {
      width: 100%;
      line-height: 40px;
      font-size: 16px;
    }
  }
}
.footer__copyright {
  background: #e6e6e6;
  display: flex;
  line-height: 50px;
  justify-content: center;
  div + div {
    margin-left: 20px;
  }
  div:first-child::after {
    content: "|";
    color: #999;
    padding-left: 20px;
  }
  a + a {
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Footer.vue